import useAppStore from "../Store";
import useI18nStore from "@/Modules/i18n/Store";

const CheckAppStatusActionHandler = async (): Promise<void> => {
  const appStore = useAppStore();
  const i18nStore = useI18nStore();
  const preferredLocale = i18nStore.getCurrentLocale();

  if (i18nStore.locale !== preferredLocale) {
    await Promise.all([i18nStore.selectLocale(preferredLocale), appStore.checkUpdate()]);

    return;
  }

  const [newTranslationsVersion] = await Promise.all([
    i18nStore.checkLocaleVersion(preferredLocale),
    appStore.checkUpdate(),
  ]);

  if (newTranslationsVersion) {
    await i18nStore.selectLocale(preferredLocale, true);
  }
};

export default CheckAppStatusActionHandler;
